<div>
  <div class="course-list-item-card-container">
    <df-course-list-item-card *ngFor="let course of courses" [smallWidth]="true" [course]="course" [isDmCard]="true"></df-course-list-item-card>
  </div>
</div>
